import { api } from '@/services'
import * as apiAdmin from '@/services/api'

const headers = {
  Authorization: localStorage.getItem('old_token'),
}

export const findAll = (params) => {
  return api.get('admin/invoice/hausefulPending', { params })
}

export const generateReport = (params) => {
  return api.get('/admin/invoice/createReport', { responseType: 'arraybuffer', params })
}

export const generateHostPendingInvoicesReport = (params) => {
  return api.get('/admin/invoice/hostPendingInvoicesReport', { responseType: 'arraybuffer', params })
}

export const generateHostPendingInvoicesReportWithoutDateLimit = () => {
  return api.get('/admin/invoice/hostPendingInvoicesReportWithoutMaxDate', { responseType: 'arraybuffer' })
}

export const generatePendingInvoicesReport = () => {
  return api.get('/admin/invoice/hostPendingInvoicesReport', { responseType: 'arraybuffer' })
}

export const show = ({ id }) => {
  const options = {
    headers,
    method: 'GET',
    url: `/admin/hausefulTakeRateInvoice/show/${id}`,
  }

  return apiAdmin.api(options)
}

export const list = ({ params }) => {
  return api.get('/admin/invoice/search', { params })
}

export const create = (invoiceData) => {
  return api.post('admin/invoice/create', invoiceData)
}

export const update = (invoiceData) => {
  return api.post('/admin/invoice/updateFile', invoiceData)
}

export const exclude = ({ id }) => {
  return api.delete(`/admin/invoice/${id}`)
}

export const attach = ({ id, filename, external_filename }) => {
  return api.post(`/admin/invoice/${id}/attachFile`, { filename, external_filename })
}

export const generateAsaas = (payments_ids) => {
  return api.post('/admin/invoice/generateAsaas', { payments_ids })
}

/**
 * Emissão em lote. Responde 200 mesmo com falhas: sucesso parcial é o caso normal, e o desfecho
 * vem por item em `results`, ligado à linha pelos mesmos `payments_ids` enviados.
 * Máximo de 20 itens por chamada (limite do backend) - quem fatia é o store.
 */
export const generateAsaasBatch = (invoices) => {
  return api.post('/admin/invoice/generateAsaasBatch', { invoices })
}

export const paymentLinkSuggestions = (invoiceId) => {
  return api.get(`/admin/invoice/${invoiceId}/paymentLinkSuggestions`)
}

export const linkPayments = (invoiceId, payments_ids) => {
  return api.post(`/admin/invoice/${invoiceId}/linkPayments`, { payments_ids })
}
